var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3C3.67157 3 3 3.67157 3 4.5V28.5C3 29.3284 3.67157 30 4.5 30H22.5C23.3284 30 24 29.3284 24 28.5V4.5C24 3.67157 23.3284 3 22.5 3H4.5ZM0 4.5C0 2.01472 2.01472 0 4.5 0H22.5C24.9853 0 27 2.01472 27 4.5V28.5C27 30.9853 24.9853 33 22.5 33H4.5C2.01472 33 0 30.9853 0 28.5V4.5Z",
    fill: "#5FFFA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 15C11.0147 15 9 17.0147 9 19.5C9 21.9853 11.0147 24 13.5 24C15.9853 24 18 21.9853 18 19.5C18 17.0147 15.9853 15 13.5 15ZM6 19.5C6 15.3579 9.35786 12 13.5 12C17.6421 12 21 15.3579 21 19.5C21 23.6421 17.6421 27 13.5 27C9.35786 27 6 23.6421 6 19.5Z",
    fill: "#5FFFA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5C12 6.67157 12.6716 6 13.5 6H13.515C14.3434 6 15.015 6.67157 15.015 7.5C15.015 8.32843 14.3434 9 13.515 9H13.5C12.6716 9 12 8.32843 12 7.5Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.f1bdcc79034583a5ccae4ad65f58fab2.svg";
export { ForwardRef as ReactComponent };